/**
 * /b-email (business email hosting) — migrated from public/js/b-email.js.
 * Doar sticky-menu + bookmark scrollspy (logica partajata cu rsdomains).
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';

new Resort(() => {
    initStickyBookmarks();
});
